import { render, staticRenderFns } from "./CbsObjectTable.vue?vue&type=template&id=404f1562&scoped=true"
import script from "./CbsObjectTable.vue?vue&type=script&lang=js"
export * from "./CbsObjectTable.vue?vue&type=script&lang=js"
import style0 from "./CbsObjectTable.vue?vue&type=style&index=0&id=404f1562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404f1562",
  null
  
)

export default component.exports